import { fetchReducer } from 'iqvia-shared';
import reduceReducers from 'reduce-reducers';

import apiNameEnums from '../../../Enums/apiNames';

const defaultState = {
  channels: [],
  isLoading: false,
};

const channels = (state = defaultState, { type }) => {
  switch (type) {
    default:
      return state;
  }
};

export default reduceReducers(channels, fetchReducer(apiNameEnums.GET_CHANNELS));



// WEBPACK FOOTER //
// ./src/JourneyBuilder/SendOptimizer/reducers/channels.js